import { Component, Inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';
import { DynamicFormQuestionComponent } from '../../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { CommonModule, DatePipe } from '@angular/common';
import { ApiservicesService } from '../../../../Services/Apis/apiservices.service';
import { Inputfiledsbase } from '../../../../inputfileds/models/inputfiledsbase';
import { AcademicyearsformService } from '../../../../inputfileds/form_services/academics/academicyearsform/academicyearsform.service';
import { Observable, forkJoin, Subscription } from 'rxjs';
import { QuestionService } from '../../../../inputfileds/form_services/question/question.service';
import { QuestionControlService } from '../../../../inputfileds/form_services/question-control.service';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { ToastService } from '../../../../Services/toast/toast.service';
import { ToastComponent } from '../../../../components/toast/toast.component';
import { TranslateDirective } from '../../../../components/Utilites/Directives/translate.directive';
// import { dateWithinYearRangeValidator } from '../../../../components/Utilites/Validations/date-range.validator';

export interface Coursemodel {
  // academic_year_id: number;
  start_date: Date;
  end_date: Date;
  // batches: [{}];
}

@Component({
    selector: 'app-addacadamiccalendar',
    imports: [
        ReactiveFormsModule,
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatDividerModule,
        DynamicFormQuestionComponent,
        MatIconModule,
        ToastComponent,
        TranslateDirective
    ],
    providers: [
        QuestionControlService,
        AcademicyearsformService,
        ApiservicesService,
    ],
    templateUrl: './addacadamiccalendar.component.html',
    styleUrl: './addacadamiccalendar.component.scss'
})

export class AddacadamiccalendarComponent {
  questions: Inputfiledsbase<string>[] | null = [];
  questions$: Observable<Inputfiledsbase<any>[]> | null;
  academicsform!: FormGroup;
  datesend!: Coursemodel;
  semisterflag: boolean = false;
  academicsdata: any = {};
  selectedBatchId: number = 0;
  datepipe = new DatePipe('en-US');
  private subscription: Subscription | undefined;

  constructor(
    private dialogRef: MatDialogRef<AddacadamiccalendarComponent>,
    private apiservice: ApiservicesService,
    private services: AcademicyearsformService,
    private router: Router,
    private qcs: QuestionControlService,
    private toast: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.questions$ = services.getacadamiccalendarform();
    this.questions$.subscribe((q) => (this.questions = q));
  }

  ngOnInit(): void {
    this.academicsform = this.qcs.toFormGroup(
      this.questions as Inputfiledsbase<string>[]
    );
    this.academicsform.addControl(
      'start_year',
      new FormControl('', [Validators.required])
    );
    this.academicsform.addControl(
      'end_year',
      new FormControl('', [Validators.required])
    );
    this.academicsform.setValidators(this.dateRangeValidator.bind(this));

    this.academicsform.patchValue({
      start_year: this.data?.data?.start_date,
      end_year: this.data?.data?.end_date
    })
  }

  dateRangeValidator(control: AbstractControl): ValidationErrors | null {
    const startYear = control.get('start_year')?.value;
    const endYear = control.get('end_year')?.value;
    const startYearValue = startYear instanceof Date ? startYear.getFullYear() : parseInt(startYear, 10);
    const endYearValue = endYear instanceof Date ? endYear.getFullYear() : parseInt(endYear, 10);

    if (startYearValue && endYearValue && endYearValue !== startYearValue && endYearValue !== startYearValue + 1) {
      return { dateRangeInvalid: true };
    }
    return null;
  };

  gotosemisters() {
    this.semisterflag = !this.semisterflag;
  }

  closeDialog(event: any) {
    // this.dialogRef.close();
    this.gotosemisters();
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.remove('animate__fadeIn');
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.add('animate__fadeOut');
    setTimeout(() => {
      this.dialogRef.close(event);
    }, 1000);
  }

  onSubmit() {
    this.academicsform.markAllAsTouched();
    const organizationData = sessionStorage.getItem('user');
    let organizationId: number | null = null;

    if (organizationData) {
      try {
        const parsedData = JSON.parse(organizationData);
        if (parsedData.data && parsedData.data.organization_id) {
          organizationId = parsedData.data.organization_id;
        } else {
          console.error('Parsed data does not contain expected structure');
        }
      } catch (error) {
        console.error('Error parsing data from sessionStorage:', error);
      }
    }
    if (organizationId === null) {
      console.error('Organization ID not found');
      return;
    }
    // const batchData = this.academicsform.value.batch;
    // const formattedBatches = batchData.map((batch: any) => batch);
    this.datesend = {
      // academic_year_id: this.academicsform.value.academic_year,
      // start_date: new Date(this.academicsform.value.start_year).getFullYear(),
      start_date: this.datepipe.transform(this.academicsform.value.start_year, 'yyyy-MM-dd') || this.academicsform.value.start_year.toJSON().slice(0, 10),
      // end_date: new Date(this.academicsform.value.end_year).getFullYear(),
      end_date: this.datepipe.transform(this.academicsform.value.end_date, 'yyyy-MM-dd') || this.academicsform.value.end_year.toJSON().slice(0, 10),
      // batches: formattedBatches,
    };

    this.createAPi(this.datesend);
  }

  createAPi(event: any) {
    this.apiservice.editacadamiccalendar(this.data.data.id, event).subscribe((res: any) => {
      if (res.code == 204 && res.status === true) {
        if (this.data.total_count == 0) {
          this.apiservice.onboarding_status_updation({ "module_name": "ACADEMICS", "sub_module_name": "ACADEMIC_CALENDAR" }).subscribe();
        }
        this.toast.showToast('success', `Successfully created`);
        this.academicsdata = res.data;
        this.closeDialog(true);
      }
      else {
        this.toast.showToast('danger', `Error: ${res.message}`);
      }
    });
  }
}
